import { useNavigate } from 'react-router-dom';
import HomeScreenButton from '../atoms/HomeScreenButton';
import { HomeScreenButtonConfig, HomeScreenButtonProps } from '../atoms/HomeScreenButton.types';

const ModulesHomeScreenButton = ({ customLabel, customIcon }: HomeScreenButtonConfig) => {
    const navigate = useNavigate();

    const navigateToModules = () => {
        navigate('modules');
    };

    const buttonProps: HomeScreenButtonProps = {
        label: customLabel || 'Modulübersicht',
        iconPath: 'icon_modules_homescreen.svg',
        customIconSvg: customIcon
    };

    return (
        <HomeScreenButton
            buttonProps={buttonProps}
            action={navigateToModules}
            isHidden={false}
            disabled={false}
        />
    );
};
export default ModulesHomeScreenButton;